/* tslint:disable */

/**
 */
export class QuanityGroupTrip {
    trips?: any[];
}
